import {
  AsyncSelectInputItem,
  AsyncSelectInputItemProps
} from 'client/ui/form/input/AsyncSelectInputItem';
import { ICategoryResult } from 'common/schema/Procedure';
import { useField } from 'formik';
import * as React from 'react';
import { ProcedureApi } from '../ProcedureApi';

export interface IProcedureCategorySelectInputProps
  extends Omit<
    AsyncSelectInputItemProps<any, any, any, ICategoryResult[]>,
    'query' | 'responseTransform' | 'optionTransform'
  > {
  name: string;
  isAdmin?: boolean;
}

/**
 * Select per la categoria
 */
export function ProcedureCategorySelectInput(
  props: IProcedureCategorySelectInputProps
) {
  const { name, isAdmin, ...otherProps } = props;
  const [field, _, helpers] = useField<string>(name);

  return (
    <AsyncSelectInputItem
      {...otherProps}
      name={name}
      query={{
        apiFn: isAdmin
          ? ProcedureApi.findCategories
          : ProcedureApi.frontend.findCategories,
        options: {
          data: {}
        }
      }}
      optionTransform={(result: ICategoryResult) =>
        ({
          label: result.category,
          value: result.category
        } as any)
      }
    />
  );
}
